import React from 'react';
import { observer } from 'mobx-react';
import { useStore } from '@ui/hooks/useStore';
import AddDeviceInDbContainer from './Add-device-in-db.container';
import AddDeviceInDbTableContainer from '../Add-device-in-db-table/Add-device-in-db-table.container';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { download } = useStore();
    if (download.uploadedDevices && download.uploadedDevices.length > 0)
        return (
            <>
                <AddDeviceInDbTableContainer onClose={onClose} />
            </>
        );
    else
        return (
            <>
                <AddDeviceInDbContainer onClose={onClose} />
            </>
        );
};

const AddDeviceInDbMainContainer = observer(Container);

export default AddDeviceInDbMainContainer;
